<template>
  <button
    type="button"
    class="btn"
    :class="variantClass"
    @click="$emit('click-handler')"
  >
    <slot> Click </slot>
  </button>
</template>

<script>
export default {
  name: "Button",
  props: {
    variant: {
      type: String,
      default: "primary"
    }
  },
  computed: {
    variantClass() {
      switch (this.variant.toLowerCase()) {
        case "secondary":
        case "gray":
        case "grey":
          return "btn-secondary";
        case "blue":
          return "btn-blue";
        case "small":
          return "btn-small";
        default:
          return "btn-primary";
      }
    }
  }
};
</script>

<style scoped>
.btn {
  @apply shadow-sm inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white transition duration-300 ease-in-out;
}
.btn:focus {
  @apply outline-none;
}
.btn:disabled {
  @apply opacity-50 cursor-not-allowed;
}

.btn-primary {
  @apply bg-green-600;
}
.btn-primary:hover {
  @apply bg-green-500 shadow-outline-green;
}
.btn-primary:focus {
  @apply shadow-outline-green border-green-700;
}
.btn-primary:active {
  @apply bg-green-700;
}

.btn-secondary {
  @apply border-gray-300 bg-gray-300 text-gray-700;
}
.btn-secondary:hover {
  @apply bg-gray-400 shadow-outline-gray;
}
.btn-secondary:focus {
  @apply shadow-outline-green border-gray-700;
}
.btn-secondary:active {
  @apply bg-gray-50 text-gray-800;
}

.btn-blue {
  @apply bg-blue-600;
}
.btn-blue:hover {
  @apply bg-blue-500 shadow-outline-blue;
}
.btn-blue:focus {
  @apply shadow-outline-blue border-blue-700;
}
.btn-blue:active {
  @apply bg-blue-700;
}

.btn-white {
  @apply border-gray-300 bg-white text-gray-700;
}
.btn-white:hover {
  @apply text-gray-500 bg-white;
}
.btn-white:focus {
  @apply outline-none border-green-300 shadow-outline-green;
}

.btn-small {
  @apply px-2 py-1;
}
</style>
